export default __webpack_public_path__ + "img/ad51bfcffe8fbd4ac4743a96a3a6b32c.svg";